import React, {Component} from 'react';
import DataCard from './DataCard';
import walterMelon from './CharacterFeature_Melon01.png';
import bandanaNana from './CharacterFeature_Banana.png';
import profSherry from './CharacterFeature_Cherry.png';
import jackApple from './CharacterFeature_Apple.png';

export default class Characters extends Component {
  render() {
    return (
      <div stylesheet={{'margin-left': 'auto', 'margin-right': 'auto'}}>
        <h1 className="centerText">Meet the Drivers!</h1>
        <hr/>
        <DataCard title="Walter Melon"
          tagline="The Lovable Old Melon"
          description={"Walter Melon is the oldest member of the FPS. In fact, he's one of the founding members of the mail service for Fruitlandia! "
          + "Walter is beloved by his co-workers and will often tell them stories about his bird-watching endeavors over lunch breaks. "
          + "Keep an eye out for him on the road though! He's proud to be employee of the month and uses his special ability to spit seats out the front "
          + "of his truck. When his seeds slam into another driver, it'll knock a package loose! Walter can take advantage of this to steal and deliver "
          + "the most packages!"}
          img={walterMelon}/>
        <hr/>
        <DataCard title="Bandana-nana"
          tagline="National Hero; Part-time Postal Driver"
          description={"Bandana-nana takes everything she does seriously. Formerly a general in Fruitlandia's armed forces, she takes the tactical "
          + "approach to running her routes. Bandana-nana takes control of small parts of the routes with her banana peel power. She can leave behind "
          + "a special banana peel to trip up her opponents and knock their packages loose. No stranger to changing her plans, she is able to pick up "
          + "and reposition her peel without losing her own packages."}
          img={bandanaNana}
          right={true}/>
        <hr/>
        <DataCard title="Professor Sherry"
          tagline="Explosive Genius"
          description={'Professor Sherry is probably the namesake of the term "Mad Scientist". Always creating new and inventive devices, '
          + "she still needs to make some money. A single mother of two, Professor Sherry doesn't have much time to waste when on the job. "
          + "Thankfully, she has her cherry bombs! Professor Sherry can drop a cherry bomb on the road. The bomb can be detonated whenever she wants "
          + "or on a timer to blast any trucks nearby! Professor Sherry is at her best when she uses this to get around her route quickly, but be careful! "
          + "Her bombs are still experimental. EVERY truck hit by the blast drops a package, including herself!"}
          img={profSherry}/>
        <hr/>
        <DataCard title="Jack Apple"
          tagline="Small Apple; Big Dreams"
          description={"Jack Apple is the youngest ever driver for the FPS, getting hired just 3 days after getting his license. As the runt of his "
          + "family, Jack has always had to prove himself and at work is no exception. Jack's truck has been specially outfitted by Professor Sherry. "
          + "Jack is able to change the size of his car between it's normal size and a smaller, more compact form with ease! Proving that bigger isn't "
          + "always better, Jack gets faster, harder to hit and packs more of a punch when he rams into his fellow drivers. But be wary! Jack's small "
          + "size may be able to turn his truck into a truck-shaped bullet, but if someone hits him he's more likely to go flying!"}
          img={jackApple}
          right={true}/>

      </div>
    )
  }
}
